export default __webpack_public_path__ + "static/media/stoopFullLogo.801c0eb6.png";